












import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class IconComponent extends Vue {
  @Prop({ type: String, default: "" }) icon!: string;
  @Prop({ type: String, default: "" }) lib!: string;
}
export default IconComponent;
